import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Behfa_Interface } from 'src/app/Interface/Behfa_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HelpService {

  constructor(private http:HttpClient) { }

  GetRecord(id:number):Observable<Array<Behfa_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Help?id="+id).pipe(
      map(data=>{
        return data as Array<Behfa_Interface>
      })
    )
  }

  GetRecordUrl(url:String):Observable<any>{
    return this.http.get(environment.BaseUrl + "Daro/Help/GetRecordUrl?url="+url).pipe(
      map(data=>{
        return data as any
      })
    )
  }

  GetSingle(id:number):Observable<Behfa_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/Help/GetSingle?id="+id).pipe(
      map(data=>{
        return data as Behfa_Interface
      })
    )
  }

  AddEditHelp(model: Behfa_Interface,id:number):Observable<Behfa_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body={
      id:model.id,
      menu_id:id,
      val:model.val+'',
      type:model.type,
      create_user: ''
    }

    return this.http.post(environment.BaseUrl + "Daro/Help/AddEdit",body,{headers}).pipe(
      map(data=>{
        return data as Behfa_Interface
      })
    )
  }

  DeleteHelp(id:number):Observable<Behfa_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/Help/Delete?id="+id).pipe(
      map(data=>{
        return data as Behfa_Interface
      })
    )
  }

  PriorityHelp(id:number):Observable<Behfa_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/Help/Priority?id="+id).pipe(
      map(data=>{
        return data as Behfa_Interface
      })
    )
  }

  uploadFile(body){

    const headers = new HttpHeaders().set('content-type', 'application/json');
    return this.http.post(environment.BaseUrl + "Daro/Help/Upload", body).pipe(
      map(data=>{

        return data
      })
    )
  }

}
